// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider-image[data-v-1f94c3b0]{width:auto;filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%);transition:all .3s}.slider-image[data-v-1f94c3b0]:hover{filter:grayscale(0);-webkit-filter:grayscale(0);-moz-filter:grayscale(0);transition:all .3s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
